export class CapacidadEspecial {

    constructor(config = {}) {
        this.model = {
            id: {
                value: null,
                export: false,
                table: false,
            },
            carnet_conadis: {
                value: null,
                export: false,
                table: false,
                header: 'CARNET DEL CONADIS:',
                required: 'Campo requerido',
            },
            discapacidad: {
                value: '',
                export: false,
                table: false,
                header: 'TIPO DE DISCAPACIDAD:',
                required: 'Discapacidad es requerida',
                maxLength: 'Máximo 200 caracteres',
                minLength: 'Mínimo 3 caracteres',
                max: 200,
                min: 3,
            },
            porcentaje_discapacidad: {
                value: null,
                export: false,
                table: false,
                header: 'PORCENTAJE DE DISCAPACIDAD:',
            },
            familiar_pendiente_discapacidad: {
                value: null,
                export: false,
                table: false,
                header: 'FAMILIAR DEPENDIENTE CON CAPACIDADES ESPECIALES:',
                required: 'Campo requerido',
            },
            parentesco_familiar_pendiente: {
                value: '',
                export: false,
                table: false,
                header: 'PARENTESCO:',
                required: 'Parentesco es requerido',
                maxLength: 'Máximo 200 caracteres',
                minLength: 'Mínimo 3 caracteres',
                max: 200,
                min: 3,
            },
            tipo_discapacidad_familiar_pendiente: {
                value: '',
                export: false,
                table: false,
                header: 'TIPO DE DISCAPACIDAD:',
                required: 'Tipo de discapacidad es requerido',
                maxLength: 'Máximo 200 caracteres',
                minLength: 'Mínimo 3 caracteres',
                max: 200,
                min: 3,
            },
            porcentaje_discapacidad_familiar_pendiente: {
                value: null,
                export: false,
                table: false,
                header: 'PORCENTAJE DE DISCAPACIDAD:',
            },
            familiar_pep: {
                value: null,
                export: false,
                table: false,
                header: 'DECLARACIÓN:',
                required: 'Campo requerido',
            },
            observacion: {
                value: '',
                export: false,
                table: false,
                header: 'OBSERVACIÓN:',
                required: 'Observación es requerida',
                maxLength: 'Máximo 500 caracteres',
                minLength: 'Mínimo 3 caracteres',
                max: 500,
                min: 3,
            },
        }
    }

    optionLabel = 'nombre';
    declaracionPep = <>Informo que habiendo leído la Lista Mínima de Cargos Públicos a ser considerados "Personas Políticamente Expuestas (PEP's), declaro bajo juramento lo siguiente:
        Me encuentro ejerciendo o tengo familiar hasta el cuarto grado de consanguinidad y segundo de afinidad con uno de los cargos públicos a ser considerados como personas
        políticamente expuestas.</>;
    msgDeclaracion = <><p>Certifico que la información proporcionada en este formulario es correcta y completa. Autorizo a TRUST FIDUCIARIA ADMINISTRADORA DE FONDOS Y FIDEICOMISOS S.A.
        a proporcionar, directa o indirectamente, la información contenida es este formulario y/o una copia del mismo a cualquier autoridad fiscal pertinente o a cualquier
        parte autorizada para auditar o realizar un control similar de TRUST FIDUCIARIA para fines fiscales; así como, a divulgar a tales autoridades fiscales o parte autorizada
        cualquier información adicional que pudiese poseer TRUST FIDUCIARIA y que es pertinente para mi calificación para cualquier beneficio reclamado con base en esta certificación.
        Acepto que la información contenida en este formulario y la información relacionada con mis cuentas en TRUST FIDUCIARIA (incluso la información sobre los saldos de cuentas y
        pagos recibidos) se notifique a las autoridades fiscales pertinentes y, que estas autoridades, proporcionen esta información a cualquier otro país enumerado en la lista anterior,
        como a un país en el cual soy residente para fines fiscales. Me comprometo a avisar inmediatamente a TRUST FIDUCIARIA sobre cualquier cambio en las circunstancias que motive que
        la información contenida en este documento sea incorrecta y a proporcionar a TRUST FIDUCIARIA un formulario actualizado y apropiado de Auto-certificación de Residencia Fiscal en
        un plazo de 30 días a partir de la fecha de cambio de circunstancias.</p></>;
    msgTratamientoDatos = <>
        <ol style={{ paddingLeft: "13px", }}>
            <li>El Responsable de los Datos Personales ha puesto en mi conocimiento su Política de Tratamiento de Datos Personales, la misma que me ha sido entregada y que consta en su página web. En ella constan los principios, cuidados y derechos respecto al tratamiento de mis datos personales.</li>
            <br />
            <li>De conformidad con el art. 8 de la Ley Orgánica de Protección de Datos Personales y art. 5 de su Reglamento, con la suscripción del presente formulario, consiento de manera libre, previa, expresa, voluntaria, y debidamente informada al Responsable de los Datos Personales, para que realice el tratamiento de mis datos personales en calidad de responsable. Entiendo que mis datos personales podrán ser compartidos con terceros, en concordancia con las disposiciones legales.</li>
            <br />
            <li>El Responsable de los Datos Personales declara que el tratamiento de datos personales se realizará dentro de los límites y de conformidad y con fundamento en lo dispuesto en el Art. 66 nº 19 de la Constitución de la República, la Ley Orgánica de Prevención, Detección y Combate del Delito de Lavado de Activos y de la Financiación de Otros Delitos y la LOPDP. El Responsable tratará mis datos personales con reserva y ha adoptado las medidas técnicas y organizativas necesarias para garantizar su seguridad, integridad y confidencialidad.</li>
            <br />
            <li>Los datos y documentación que aporto mediante el presente formulario son veraces y exactos, y el Responsable podrá efectuar las validaciones que considere pertinentes.</li>
            <br />
            <li>Autorizo al Responsable de los Datos Personales a contactarme y enviarme comunicaciones por cualquier medio, teniendo en consideración la finalidad antes expresada. Asimismo, podré comunicarme con el Responsable en cualquier momento si tengo preguntas o solicitudes sobre el tratamiento de mis datos personales.</li>
        </ol>
    </>;
}
